import React from 'react';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';

import assets from 'marketing-website/configs/pages/enterprise/assets';

import styles from './style/try.module.css';

export default function Try() {
  return (
    <div className={styles.main}>
      <div className={styles.wrap}>
        <div className={styles.container}>
          <div className={styles.left}>
            <Heading tag="h2" weight="bold" size="xxxxl" color="white">
              Ready to try it out?
            </Heading>
            <MaxWidth value={388}>
              <Paragraph size="xl" color="white">
                Join thousands of large design teams and switch to Marvel
                Enterprise 3
              </Paragraph>
            </MaxWidth>
            <Spacing size="m" type="margin" position="top">
              <Link to="/enterprise/request-demo">
                <Button
                  size="extraLarge"
                  color="slate"
                  hover="white"
                  background="white"
                  shape="rounded"
                >
                  Request a demo
                </Button>
              </Link>
            </Spacing>
          </div>
          <div className={styles.right}>
            <div className={styles.imageChild}>
              <Image hasShadow={false} {...assets.imageEditor} block />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/Try.js